export const VTMN_LISTITEM_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};
